/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteVSTSAccountInput = {|
  vstsAccount?: ?string,
  csrfToken?: ?string,
  socketClientId?: ?string,
  clientMutationId?: ?string,
|};
export type deleteVstsAccountMutationVariables = {|
  input: DeleteVSTSAccountInput
|};
export type deleteVstsAccountMutationResponse = {|
  +deleteVSTSAccount: ?{|
    +viewer: ?{|
      +company: ?{|
        +vstsEnabled: ?boolean,
        +vstsAccount: ?$ReadOnlyArray<?string>,
        +vstsEstimateField: ?string,
      |}
    |}
  |}
|};
export type deleteVstsAccountMutation = {|
  variables: deleteVstsAccountMutationVariables,
  response: deleteVstsAccountMutationResponse,
|};
*/


/*
mutation deleteVstsAccountMutation(
  $input: DeleteVSTSAccountInput!
) {
  deleteVSTSAccount(input: $input) {
    viewer {
      company {
        vstsEnabled
        vstsAccount
        vstsEstimateField
        id
      }
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteVSTSAccountInput!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "vstsEnabled",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "vstsAccount",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "vstsEstimateField",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteVstsAccountMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteVSTSAccountPayload",
        "kind": "LinkedField",
        "name": "deleteVSTSAccount",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Viewer",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Company",
                "kind": "LinkedField",
                "name": "company",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteVstsAccountMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteVSTSAccountPayload",
        "kind": "LinkedField",
        "name": "deleteVSTSAccount",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Viewer",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Company",
                "kind": "LinkedField",
                "name": "company",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "deleteVstsAccountMutation",
    "operationKind": "mutation",
    "text": "mutation deleteVstsAccountMutation(\n  $input: DeleteVSTSAccountInput!\n) {\n  deleteVSTSAccount(input: $input) {\n    viewer {\n      company {\n        vstsEnabled\n        vstsAccount\n        vstsEstimateField\n        id\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '2a1a0ea885de4f422fcbf60c5ee1bfd8';

module.exports = node;
